import { blurWhenFocusLeaves } from '@/utils/blurWhenFocusLeaves';
import { SelectField } from '@medenterprises/pulse-ui';
import React, { useId } from 'react';
import { Controller } from 'react-hook-form';
import type { Control, FieldErrors } from 'react-hook-form';
import type { FormDropdown } from 'types/cms';

import usePulseFieldAttributes from './usePulseFieldAttributes';
import { fieldId, getFieldError, textRules } from './utils';

const Dropdown = ({
  control,
  errors,
  identifier,
  label,
  dropdown_items,
  required,
}: FormDropdown & { control: Control; errors?: FieldErrors }) => {
  const errorMessage = getFieldError(errors, identifier);
  const id = fieldId(identifier, useId());
  const containerRef = usePulseFieldAttributes('[role="combobox"]', {
    invalid: !!errorMessage,
    required: !!required,
    testId: identifier,
  });
  const options = dropdown_items.map(({ value, display_value }) => ({
    value,
    label: display_value ? display_value : value,
  }));

  return (
    <Controller
      name={identifier}
      control={control}
      defaultValue=""
      rules={textRules(required)}
      render={({ onChange, onBlur, value }) => (
        <div ref={containerRef} onBlur={blurWhenFocusLeaves(onBlur)}>
          <SelectField
            id={id}
            label={label}
            options={options}
            value={value}
            onChange={onChange}
            required={required}
            error={!!errorMessage}
            errorMessage={errorMessage}
          />
        </div>
      )}
    />
  );
};

export default Dropdown;
